import React, { useState } from "react";
import BulkVpaUpload from "./BulkVpaUpload";
import PreauthVpaManager from "./PreauthVpaManager";

type TabKey = "tenant" | "preauth";

const TABS: { key: TabKey; label: string }[] = [
  { key: "tenant", label: "Tenant VPA Upload" },
  { key: "preauth", label: "Preauth VPA Upload" },
];

const VpaUploadPage: React.FC = () => {
  const [activeTab, setActiveTab] = useState<TabKey>("tenant");

  return (
    <div className="bg-white min-h-full">
      <div className="max-w-7xl mx-auto px-7 pt-6">
        <div role="tablist" aria-label="VPA upload type" className="flex gap-6 border-b border-cardborder">
          {TABS.map((tab) => (
            <button
              key={tab.key}
              id={`vpa-tab-${tab.key}`}
              role="tab"
              type="button"
              aria-selected={activeTab === tab.key}
              aria-controls={`vpa-panel-${tab.key}`}
              onClick={() => setActiveTab(tab.key)}
              className={`pb-3 text-sm font-medium focus:outline-none border-b-2 -mb-px ${
                activeTab === tab.key ? "border-brand text-brand" : "border-transparent text-gray-500 hover:text-gray-700"
              }`}
            >
              {tab.label}
            </button>
          ))}
        </div>
      </div>

      <div id={`vpa-panel-${activeTab}`} role="tabpanel" aria-labelledby={`vpa-tab-${activeTab}`}>
        {activeTab === "tenant" ? (
          <BulkVpaUpload />
        ) : (
          <>
            <div className="flex border-b border-cardborder mb-8 max-w-7xl mx-auto px-7 py-8">
              <h2 className="text-2xl font-bold text-gray-900">Preauth VPA Upload</h2>
            </div>
            <PreauthVpaManager />
          </>
        )}
      </div>
    </div>
  );
};

export default VpaUploadPage;
